import { Grow, InputAdornment, TextField } from '@material-ui/core';
import { SearchOutlined, Close as CloseIcon } from '@material-ui/icons';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { EQueryStringKey } from 'services/QueryString/QueryStringService';

const CustomBrandSearch = (props) => {
  const location = useLocation();
  const history = useHistory();

  const { onSearch, searchText } = props;

  const handleTextChange = (value) => {
    onSearch(value);

    const params = new URLSearchParams({ [EQueryStringKey.Name]: value });
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  useEffect(() => {
    let mounted = true;

    const brandNameQueryString = new URLSearchParams(location.search).get(
      EQueryStringKey.Name,
    );

    if (mounted && brandNameQueryString) {
      onSearch(brandNameQueryString);
    }

    return () => (mounted = false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grow appear in timeout={300}>
      <TextField
        placeholder="Search"
        size="small"
        value={searchText || ''}
        onChange={(event) => handleTextChange(event.target.value)}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlined />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <CloseIcon style={{ cursor: 'pointer' }} onClick={() => handleTextChange('')} />
            </InputAdornment>
          ),
        }}
      />
    </Grow>
  );
};

export default CustomBrandSearch;
